module.exports = __webpack_public_path__ + "empty_cart.svg?9625adc4776aedf1807d2b1f960fbb91";